import ManualBreadcrumb from '../../components/manual/ManualBreadcrumb';
import ManualSection from '../../components/manual/ManualSection';
import ManualAlert from '../../components/manual/ManualAlert';
import ManualStep from '../../components/manual/ManualStep';

function ManualRelatoriosPage() {
  return (
    <div className="manual-page">
      <ManualBreadcrumb items={[{ label: 'Relatórios' }]} />
      
      <div className="manual-header">
        <h1 className="manual-title">
          <i className="bi bi-pie-chart me-3"></i>
          Relatórios
        </h1>
        <p className="manual-subtitle">
          Acompanhe indicadores e gráficos de movimentações e atendimentos
        </p>
      </div>

      <ManualSection icon="bi-graph-up" title="Acessando os Relatórios">
        <ManualStep number="1" title="Abra o menu de relatórios">
          No menu lateral esquerdo, clique em <strong>"Relatórios"</strong>.
        </ManualStep>

        <ManualStep number="2" title="Visualize as informações">
          Você verá uma tela com gráficos calculados a partir das movimentações e atendimentos
          carregados do sistema.
        </ManualStep>

        <ManualAlert type="important">
          O acesso depende da permissão <code>relatorios.view</code>. A tela busca as movimentações
          com status <strong>Todos</strong> e atualiza os indicadores quando recebe eventos de alteração.
        </ManualAlert>
      </ManualSection>

      <ManualSection icon="bi-bar-chart-line" title="Tipos de Relatórios Disponíveis">
        <div className="manual-report-type">
          <h4><i className="bi bi-pie-chart me-2"></i>Atendimentos por Área</h4>
          <p>
            Mostra quantos atendimentos foram realizados por cada setor:
            Promotoria, Defensoria, Saúde, Educação e Especialistas.
            Útil para avaliar a demanda de cada área.
          </p>
        </div>

        <div className="manual-report-type">
          <h4><i className="bi bi-bar-chart me-2"></i>Movimentações por Status</h4>
          <p>
            Compara o número de movimentações em aberto com as já finalizadas.
            Ajuda a entender o volume de trabalho pendente.
          </p>
        </div>

        <div className="manual-report-type">
          <h4><i className="bi bi-clock-history me-2"></i>Tempo de Permanência</h4>
          <p>
            Apresenta o tempo médio de conclusão de atendimentos por área
            (Promotoria, Defensoria, Saúde, Educação e Especialistas).
          </p>
        </div>

        <div className="manual-report-type">
          <h4><i className="bi bi-activity me-2"></i>Iniciadas x Finalizadas</h4>
          <p>
            Mostra a série dos últimos 7 dias, comparando movimentações iniciadas e finalizadas.
            Ajuda a acompanhar ritmo operacional recente.
          </p>
        </div>

        <div className="manual-report-type">
          <h4><i className="bi bi-gavel me-2"></i>Decisões mais frequentes</h4>
          <p>
            Considera movimentações finalizadas e agrupa as decisões mais usadas. Quando houver
            Flagrante + MBA, o sistema considera as decisões específicas de flagrante e MBA.
          </p>
        </div>
        
        <div className="manual-report-type">
          <h4><i className="bi bi-diagram-3 me-2"></i>Pipeline por Situação Atual</h4>
          <p>
            Exibe o agrupamento das movimentações por situação atual, ajudando a identificar
            gargalos e concentração de casos.
          </p>
        </div>
      </ManualSection>

      <ManualSection icon="bi-broadcast" title="Atualização em Tempo Real">
        <p>
          A página escuta eventos de movimentação e faz uma atualização suave, sem trocar toda a tela
          por um carregamento completo. Caso a conexão em tempo real falhe, os dados permanecem visíveis
          até a próxima atualização manual ou recarregamento da página.
        </p>
      </ManualSection>

      <ManualSection icon="bi-question-circle" title="Dúvidas Comuns">
        <div className="manual-faq-item">
          <h5>Por que alguns gráficos aparecem vazios?</h5>
          <p>
            Se não houver dados para o período selecionado, o gráfico ficará vazio.
            Tente ampliar o período ou remover filtros.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Os números estão sempre atualizados?</h5>
          <p>
            Sim! Os relatórios são calculados em tempo real com base nos dados mais recentes
            do sistema.
          </p>
        </div>

        <div className="manual-faq-item">
          <h5>Posso exportar ou imprimir diretamente por esta tela?</h5>
          <p>
            Nesta versão, a página de relatórios é voltada para análise visual em tempo real.
            Caso precise de exportações formais, valide com a equipe administradora do sistema
            quais rotinas oficiais devem ser usadas.
          </p>
        </div>
      </ManualSection>
    </div>
  );
}

export default ManualRelatoriosPage;
